import { useEffect, useState } from "react";
import axios from "axios";
import AdminLayout from "../components/AdminLayout";
import { useAuth } from "../context/AuthContext";
import { Package, MessageSquare, Image as ImageIcon, TrendingUp } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const StatCard = ({ icon: Icon, label, value, sublabel, testid }) => (
  <div className="bg-white border border-zinc-200 p-6" data-testid={testid}>
    <div className="flex items-start justify-between">
      <div>
        <p className="text-xs uppercase tracking-wider text-zinc-500 font-bold">{label}</p>
        <p className="text-4xl font-black text-[#0A0A0A] mt-2" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>{value}</p>
        {sublabel && <p className="text-xs text-zinc-500 mt-1">{sublabel}</p>}
      </div>
      <div className="w-10 h-10 bg-zinc-100 flex items-center justify-center">
        <Icon className="w-5 h-5 text-[#0A0A0A]" />
      </div>
    </div>
  </div>
);

const AdminDashboard = () => {
  const { authHeaders } = useAuth();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/admin/stats`, { headers: authHeaders() });
        setStats(data);
      } catch (e) {
        if (process.env.NODE_ENV !== 'production') console.error(e);
      } finally {
        setLoading(false);
      }
    })();
  }, [authHeaders]);

  return (
    <AdminLayout>
      <div data-testid="admin-dashboard-page">
        <h1 className="text-3xl font-bold text-[#0A0A0A] mb-2" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Dashboard</h1>
        <p className="text-zinc-600 mb-8">Përmbledhje e shpejtë e sistemit</p>

        {loading ? (
          <div className="text-zinc-500">Duke ngarkuar...</div>
        ) : stats ? (
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <StatCard
              icon={Package}
              label="Produkte"
              value={stats.products.total}
              sublabel={`${stats.products.active} aktive`}
              testid="stat-products"
            />
            <StatCard
              icon={ImageIcon}
              label="Galeria"
              value={stats.gallery_items}
              sublabel="foto totale"
              testid="stat-gallery"
            />
            <StatCard
              icon={MessageSquare}
              label="Kontakte"
              value={stats.contacts.total}
              sublabel={`${stats.contacts.new} të reja`}
              testid="stat-contacts"
            />
            <StatCard
              icon={TrendingUp}
              label="Status"
              value="OK"
              sublabel="Sistemi funksional"
              testid="stat-system"
            />
          </div>
        ) : (
          <div className="text-red-600">Gabim duke ngarkuar statistikat</div>
        )}
      </div>
    </AdminLayout>
  );
};

export default AdminDashboard;
